var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 27.6,
    viewBox: "0 0 24 27.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_4737448_account_user_avatar_profile_icon",
    "data-name": "4737448_account_user_avatar_profile_icon",
    transform: "translate(-4 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15987",
    "data-name": "Path 15987",
    d: "M20,13a6,6,0,1,1,6-6,6,6,0,0,1-6,6Zm0-9.6A3.6,3.6,0,1,0,23.6,7,3.6,3.6,0,0,0,20,3.4Z",
    transform: "translate(-4)",
    fill: "#2fda7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15988",
    "data-name": "Path 15988",
    d: "M26.8,37.4H5.2A1.2,1.2,0,0,1,4,36.2V32.6A9.6,9.6,0,0,1,13.6,23h4.8A9.6,9.6,0,0,1,28,32.6v3.6A1.2,1.2,0,0,1,26.8,37.4ZM6.4,35H25.6V32.6a7.2,7.2,0,0,0-7.2-7.2H13.6a7.2,7.2,0,0,0-7.2,7.2Z",
    transform: "translate(0 -8.8)",
    fill: "#2fda7b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.25786b320d35af48a42748b551b558c5.svg";
export { ForwardRef as ReactComponent };